
import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'teamFilter' })
export class TeamFilterPipe implements PipeTransform {
    transform(value, args?) {
        // console.log(args)
        // console.log(value)
        let searchText = 'Venom';

        if (value) {
            return value.filter(project => {
                if (project) {
                    // console.log(project)
                    return !project.playerss.every(outcome => {
                        // console.log(outcome)
                        return (!outcome.name.includes(args))
                    });

                }
            });
        }
    }
}